import { FC, useState } from "react";
import useI18n from "../../hooks/useTranslations";
import ModalDialog from "../ui/ModalDialog";
import ProjectSharingAccessesContent from "./ProjectSharingAccessesContent";

interface ProjectSharingAccessesDialogProps {
  projectId: string;
  projectName?: string;
  isAdmin?: boolean;
  onClose: () => void;
}

const ProjectSharingAccessesDialog: FC<ProjectSharingAccessesDialogProps> = ({
  projectId,
  projectName,
  isAdmin,
  onClose,
}) => {
  const i18n = useI18n();
  const [isReady, setIsReady] = useState(false);
  const onContentReady = () => setIsReady(true);

  if (!isReady) {
    return (
      <div style={{ display: "none" }}>
        <ProjectSharingAccessesContent projectId={projectId} isAdmin={isAdmin} onReady={onContentReady} />
      </div>
    );
  }

  return (
    <ModalDialog
      onClose={onClose}
      fitContent
      title={projectName ? `${i18n.translation.projects.sharings}: ${projectName}` : i18n.translation.projects.sharings}
    >
      <ProjectSharingAccessesContent projectId={projectId} isAdmin={isAdmin} onReady={onContentReady} />
    </ModalDialog>
  );
};

export default ProjectSharingAccessesDialog;
